import React from 'react';
import { motion } from 'framer-motion';

const FeatureStack = ({ features = [] }) => {
  return (
    <div className="space-y-3">
      {features.map((f, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, x: 32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
          whileHover={{ y: -3 }}
          className="glass-card p-5 group cursor-default"
        >
          <div className="flex gap-4 items-start">
            <div className="feature-icon flex-shrink-0">
              <f.icon className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-base mb-1.5 text-[var(--text-primary)] group-hover:gradient-text transition-all">
                {f.title}
              </h3>
              <p className="text-[var(--text-secondary)] text-sm leading-relaxed">
                {f.description}
              </p>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default FeatureStack;
